import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faSave,
  faUndo,
  faTrashAlt,
} from '@fortawesome/pro-solid-svg-icons';
import { updateCampaign } from '../../actions/campaign';
import EditRows from './edit-campaign';

class CampaignRow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      values: {},
      validations: {},
    };
  }

  componentDidMount() {
    this.reset();
  }

  reset = () => {
    const { campaign } = this.props;

    const newObject = { ...campaign };
    Object.keys(newObject).forEach((key) => {
      newObject[key] = true;
    });

    this.setState({
      values: campaign,
      validations: newObject,
    });
  };

  handleEditClick = () => {
    this.setState({ editing: true });
  };

  openDeleteCampaign = () => {
    const { openDeleteCampaign, selectDeleteCampaign, campaign } = this.props;

    openDeleteCampaign();
    selectDeleteCampaign(campaign);
  };

  validate = (value, pattern) => {
    const matches = value.match(pattern) || [];
    return matches.length > 0;
  };

  handleChange = (event) => {
    const valid = this.validate((event.target.value || ''), event.target.pattern);

    const isNumberValue = [
      'q_to_shoppers',
      'es_to_quotes',
      'ec_to_enrollments',
      'es_to_shoppers',
      'ec_to_shoppers',
    ].includes(event.target.id);

    event.persist();
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        [event.target.id]: (isNumberValue ? Number(event.target.value) : event.target.value),
      },
      validations: { ...prevState.validations, [event.target.id]: valid },
    }));
  };

  handleUpdate = async () => {
    try {
      const { values } = this.state;
      const { campaign: { id } } = this.props;

      await updateCampaign(id, values);
    } catch (error) {
      // do nothing
    } finally {
      this.setState({ editing: false });
    }
  };

  render() {
    const {
      campaign,
      agenciesAvailable,
      validation,
      updating,
    } = this.props;
    const { editing, values, validations } = this.state;
    const erroring = !Object.values(validations).reduce((prev, curr) => prev && curr, true);
    const filteredAgencies = (campaign?.agencies ?? [])
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((agency) => {
        const filteredAgency = agenciesAvailable
          .find((selectAgency) => selectAgency.id === agency);

        if (!filteredAgency) {
          return null;
        }

        return (
          <div key={filteredAgency.id}>
            {filteredAgency.name ? filteredAgency.name : ''}
          </div>
        );
      });

    return (
      <tr>
        {editing ? (
          <EditRows
            values={values}
            validation={validation}
            validations={validations}
            updating={updating}
            onChange={this.handleChange}
          />
        ) : (
          <>
            <td>
              <h6>{campaign.name}</h6>
              <div>{`Start Date:  ${campaign.start}`}</div>
              <div>{`End Date:  ${campaign.end}`}</div>
            </td>
            <td>
              <div>{`${campaign.q_to_shoppers}% Quotes Saved as % of Beneficiaries`}</div>
              <div>{`${campaign.es_to_quotes}% Enrollments Started as % of Quotes Saved`}</div>
              <div>{`${campaign.ec_to_enrollments}% Enrollments Completed as % of Enrollments Started`}</div>
              <div>{`${campaign.es_to_shoppers}% Enrollments Started as % of Beneficiaries`}</div>
              <div>{`${campaign.ec_to_shoppers}% Enrollments Completed as % of Beneficiaries`}</div>
            </td>
          </>
        )}
        <td>
          {filteredAgencies.length ? filteredAgencies : 'No Agencies Associated.'}
        </td>
        <td className="text-right pe-2">
          {editing ? (
            <>
              <Button
                color="white"
                onClick={this.handleUpdate}
                disabled={erroring || updating}
                title="Save"
              >
                {updating && (
                  <Spinner size="sm" className="me-2" />
                )}
                <FontAwesomeIcon icon={faSave} fixedWidth />
              </Button>
              <Button
                color="white"
                onClick={() => {
                  this.setState({ editing: false });
                  this.reset();
                }}
                disabled={updating}
                title="Undo"
              >
                <FontAwesomeIcon icon={faUndo} fixedWidth />
              </Button>
            </>
          ) : (
            <Button color="white" onClick={this.handleEditClick} title="Edit">
              <FontAwesomeIcon icon={faEdit} fixedWidth />
            </Button>
          )}
          <Button color="white" onClick={this.openDeleteCampaign} title="Delete">
            <FontAwesomeIcon icon={faTrashAlt} fixedWidth />
          </Button>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (store) => ({
  agenciesAvailable: store.agencies.records,
  validation: store.theme.validation,
  updating: store.campaign.updating,
});

const mapDispatchToProps = {
  openDeleteCampaign: () => ({ type: 'OPEN_DELETE_CAMPAIGN' }),
  selectDeleteCampaign: (payload) => ({ type: 'SELECT_DELETE_CAMPAIGN', payload }),
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignRow);
